import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '@/stores/authStore';

export function LoginPage() {
  const navigate = useNavigate();
  const { signIn, session, initialize } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hasError, setHasError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    void initialize();
  }, [initialize]);

  useEffect(() => {
    if (session) {
      navigate('/dashboard', { replace: true });
    }
  }, [session, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setHasError(false);
    setSubmitting(true);
    const { error } = await signIn(email, password);
    setSubmitting(false);
    if (error) {
      setHasError(true);
      toast.error('Email o contraseña incorrectos.');
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gn-bg px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="font-headline text-4xl font-bold text-gn-primary-forest">
            Green Panel
          </h1>
          <p className="mt-2 text-sm text-gn-ink-muted">
            Gestión diaria · Green Nutrition
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="gn-card space-y-5 rounded-signature"
        >
          <div>
            <label
              htmlFor="email"
              className="mb-1.5 block text-sm font-medium text-gn-ink"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              aria-invalid={hasError}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-gn border border-gn-border bg-gn-white px-4 py-2.5 text-gn-ink outline-none focus:border-gn-primary aria-[invalid=true]:border-red-500"
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="mb-1.5 block text-sm font-medium text-gn-ink"
            >
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              aria-invalid={hasError}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-gn border border-gn-border bg-gn-white px-4 py-2.5 text-gn-ink outline-none focus:border-gn-primary aria-[invalid=true]:border-red-500"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="gn-btn-primary w-full disabled:opacity-50"
          >
            {submitting ? 'Entrando…' : 'Entrar'}
          </button>

          <Link
            to="/forgot-password"
            // Enlace suelto bajo el boton de entrar, no dentro de una frase:
            // 44 px de alto tactil (AC-56).
            className="flex min-h-[44px] w-full items-center justify-center text-center text-sm text-gn-primary-forest hover:underline"
          >
            ¿Olvidaste tu contraseña?
          </Link>
        </form>

        <p className="mt-6 text-center text-xs text-gn-ink-muted">
          embed.build · Green Nutrition · 2026
        </p>
      </div>
    </div>
  );
}
